import { decryptLocalStorage } from "../utils/localStorage.utils";

export const TOKEN = () => {
    return decryptLocalStorage(localStorage.getItem('advy-admin-token'));
};

export const USER_ID = () => {
    return decryptLocalStorage(localStorage.getItem("uid"))
}

export const PROFILE = () => {
    return decryptLocalStorage(localStorage.getItem("profile"))
}

export const ACCESS_LIST = () => {
    return decryptLocalStorage(localStorage.getItem("admin-access-list"))
}